import { useDeleteExternalConnectionMutation } from 'shared/hooks/queries/use-delete-external-connection-mutation';

export const useDeleteExternalConnection = () => {
  const { mutate } = useDeleteExternalConnectionMutation();

  return mutate;
};
